<template>
  <div>
    <b-container>
      <b-row class="justify-content-center">
        <b-col cols="12" md="8" lg="6" class="align-self-center">
          <h1>Login</h1>
          <b-form @submit="submitLoginForm">
            <b-form-group label="Email address" label-for="supplier-email">
              <b-form-input
                v-model="email"
                type="email"
                id="supplier-email"
                placeholder="Enter email"
              />
            </b-form-group>
            <b-form-group label="Password" label-for="supplier-password">
              <b-form-input
                v-model="password"
                type="password"
                id="supplier-password"
                placeholder="Password"
              />
            </b-form-group>
            <b-row>
              <b-col cols="6" class="text-left">
                <b-button variant="success"  type="submit">
                  Submit
                </b-button>
              </b-col>
              <b-col cols="6" class="text-right">
              <b-button variant="link" size="sm" v-b-modal="'password-reset-modal'">
                  Reset Password
              </b-button>
              </b-col>
              <b-col cols="12" class="text-left mt-3">
                <b-alert dismissible v-model="error.login" variant="danger">
                  Login Error: Did you use the right credentials?
                </b-alert>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      id="password-reset-modal"
      ref="password-reset-modal"
      centered
      ok-only
      title="Reset Password">
      <p>
        Please contact a supply agent to reset your password:
        <a href="mailto:newsourcing@chronext.com">newsourcing@chronext.com</a>
      </p>
    </b-modal>
  </div>
</template>

<script>
import store from 'src/store/index';

export default {
  data: function() {
    return {
      email: '',
      password: '',
      error: {
        login: false,
      },
    };
  },
  mounted: function() {
    this.email = this.emailFromQuery();
  },
  watch: {
    // eslint-disable-next-line
    email(oldVal, newVal) {
      this.error.login = false;
    },
    // eslint-disable-next-line
    password(oldVal, newVal) {
      this.error.login = false;
    },
  },
  methods: {
    login(payload) {
      store
        .dispatch('login', payload)
        .then(() => {
          console.log('user logged in');
        })
        .catch((error) => {
          console.log(error);
          this.error.login = true;
        });
    },
    submitLoginForm(event) {
      this.login({ email: this.email, password: this.password });
      event.preventDefault();
    },
    emailFromQuery() {
      var searchParams = new URLSearchParams(document.location.search);
      if (searchParams.has('email')) {
        return decodeURIComponent(searchParams.getAll('email'));
      }
      return '';
    },
  },
  name: 'Login',
};
</script>